module.exports = __webpack_public_path__ + "static/img/02.58278c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/02.png
// module id = +o78
// module chunks = 1